export const isMacOs = () => navigator.userAgent.indexOf("Mac") !== -1

export const isSafari = () => {
    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') == -1 &&
        navigator.userAgent.indexOf('FxiOS') == -1;
    return isSafari
}
